import * as moment from 'moment';
import {TripEventType} from './trip-event-type';

export class TripEvent {
  public id: string;
  public type: TripEventType;
  public happenedAt: moment.Moment;
  public loadId: string;
  public referenceId: string;
  public referenceDate: moment.Moment;

  static fromDto(p): TripEvent {
    const event = new TripEvent();
    event.id = p.id;
    event.loadId = p.load_id;
    event.happenedAt = moment(p.happened_at);
    event.type = p.event_type;
    event.referenceId = p.reference_id;
    event.referenceDate = moment(p.reference_date);

    return event;
  }
}
